<template>
    <div class="mas012" :style="dBHeight" id="mas012">
        <div class="txt" v-html="$i18nUtil.trans('message.Intro.001','업무공유시스템에서 <b>공동의 과제를 생성</b>하고<br><b>멤버들과 협업</b>하여 나의 <b>목표와 성과</b>를 이뤄보세요.')"></div>
        <div class="clear">
            <div class="fl">
                <div class="tit">01. {{$i18nUtil.trans("message.Intro.011","과제 공간 생성")}}</div>
                <div class="txt" v-html="$i18nUtil.trans('message.Intro.002','과제를 수행할 <b>공간과 멤버를 구성하여</b><br>나의 과제를 열심히 수행해보세요.')"></div>
                <div class="img"></div>
                <div class="ref" v-html="$i18nUtil.trans('message.Intro.003','* 과제가 이미 생성된 경우 멤버로 활동해<br>주세요. 과제 멤버 추가 여부는 좌측 <br>알림에서 확인 가능합니다.')"></div>
                <div class="txtc"><button type="button" class="btn-primary-small black" @click="addProject">{{ $i18nUtil.trans("button.project.add","과제 추가") }}</button></div>
            </div>            
            <div class="fl">
                <div class="tit">02. {{ $i18nUtil.trans("message.Intro.013","보드에서 업무 협업") }}</div>
                <div class="txt" v-html="$i18nUtil.trans('message.Intro.004','과제/나의 공간 <b>보드</b>에서 <br>멤버들과 <b>컨텐츠를 등록</b>하고 <br><b>실시간 협업 및 정보를 공유</b>해보세요.')"></div>
                <div class="img"></div>
                <div class="ref" v-if="okrUse !== 'false'" v-html="$i18nUtil.trans('message.Intro.005','* 보드는 OKR과 연결하여 관리할 수<br> 있습니다.')"></div>
                <div class="txtc"><button type="button" class="btn-primary-small black" @click="createBoard">{{ $i18nUtil.trans("button.paper.add","보드 추가") }}</button></div>
            </div>
            <div class="fl" v-if="tenantId !== '201'">
                <div class="tit">03. {{$i18nUtil.trans("message.Intro.012","할 일 관리")}}</div>
                <div class="txt" v-html="$i18nUtil.trans('message.Intro.006','멤버들에게 <b>요청한 할 일과</b><br><b>직접 수행한 할 일을 관리</b>해보세요.')"></div>
                <div class="img"></div>
                <div class="ref" v-html="$i18nUtil.trans('message.Intro.007','* 생성한 보드를 할 일에 연결하여 관리해<br>보세요.')"></div>
                <div class="txtc"><button type="button" class="btn-primary-small black" @click="showTodo">{{$i18nUtil.trans("button.todo.manage","할 일 관리")}}</button></div>
            </div>
            <div class="fl" v-if="tenantId !== '418502'">
                <div class="tit">{{tenantId !== '201'? '04. ':'03. '}}{{ $i18nUtil.trans("message.Intro.014","OKR 관리") }}</div>
                <div class="txt" v-html="$i18nUtil.trans('message.Intro.008','<b>OKR을 수행 중 보드와 연결</b>하여<br>관리해보세요. <b>협업한 보드는 피드백</b>을<br>받아 나의 성과로 이뤄보세요.')"></div>
                <div class="img"></div>
                <div class="ref"></div>
                <div class="txtc"><button type="button" class="btn-primary-small black" @click="showOkrMain">{{ $i18nUtil.trans("button.okr.manage","OKR 관리") }}</button></div>
            </div>
        </div>
        <div class="btm clear">
            <div class="fl">
                <div class="txt" v-html="$i18nUtil.trans('message.Intro.009','업무공유시스템 사용이 궁금하세요? 우측 하단 <b>고객센터</b> 메뉴에서 언제든지 사용법을 확인해보세요.')"></div>
            </div>
            <div class="fr">
                <input type="checkbox" id="one" v-model="introStatus" @change="changeIntroStatus($event)"><label for="one">{{ $i18nUtil.trans("message.Intro.010","다음에 인트로 화면 다시보지 않기") }}</label>
            </div>
        </div>
        <modals-container @registBoard="registBoard"/>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";
import RegistIntroBoardModal from "@/components/cowork/general/board/modal/RegistIntroBoardModal";
import CreateProject from "@/components/cowork/general/project/modal/CreateProject";
export default {
    data() {
        return {
            tenantId: localStorage.getItem("tenantId"),
            okrUse: localStorage.getItem("okrUse"),
            introStatus : null,
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },
            dBHeight: {
                'min-height': (window.innerHeight - 50 - 103) + 'px',
            },
        };
    },
    mounted(){
        if(this.tenantId === '418502' || this.tenantId === '201'){
            document.getElementById("mas012").style.width = "809px";
        }
    },
    methods : {
        ...mapActions("modals", ["showModal", "showToast", "showDialog"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("restAction", ["COWORK_REST_ALL_ACTION"]),
        // /* 과체 추가 */
        addProject() {
            let modalInfo = {
                title: this.$i18nUtil.trans("title.CreateProject.001","과제 등록"),
                width: "800px",
                height: "743px",
                obj: this.$modal,
                listType: this.listType,
                component: CreateProject,
            };
            this.showModal(modalInfo);
        },
        /* 보드 만들기 모달 호출 */
        createBoard() {
            let obj = this;
            let reqData = {
                url : "/api/copaper/paper/getGeneratedPaperId",
                method : "post",
                params: {
                    deptId: null,
                    parentDeptId: null,
                },
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
                let errorCode = res.errorCode;
                let addPaperId = res.result;
                let modalInfo = null;
                if(obj.tenantId == '201'){
                    modalInfo = {
                        title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
                        name: "registBoard",
                        method: "post",
                        width: "800px",
                        // height: "516px",
                        obj: obj.$modal,
                        paperId: addPaperId,
                        groupId: null,
                        component: RegistIntroBoardModal,
                    };
                } else {
                    modalInfo = {
                        title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
                        name: "registBoard",
                        method: "post",
                        width: "800px",
                        // height: "493px",
                        obj: obj.$modal,
                        paperId: addPaperId,
                        categoryMid: null,
                        groupId: null,
                        paperTitle: "",
                        contentPath: "",
                        docGrade: "SECRET",
                        component: RegistBoardModal,
                    };
                }
                obj.showModal(modalInfo);
            })
            .catch(function (err) {
            console.log(err);
            });
        },
       /* 보드 생성 API 호출 */
        registBoard(_data) {
            let obj = this;
            let reqData = {
                url : "/api/copaper/paper/addPaper",
                method : "post",
                params: {
                    paperTitle : _data.paperTitle, 
                    paperId: _data.paperId, 
                    groupId : _data.groupId, 
                    categoryMid : _data.categoryMid, 
                    contentPath : _data.contentPath, 
                    docGrade: _data.docGrade, 
                    blockType: "CONTENT",
                    link:"/general/board/" + _data.paperId,
                    tagList: _data.tagList
                },
            };
            //프로그레스바 시작
            obj.showLoadingbar();
            obj
            .COWORK_REST_ALL_ACTION(reqData)
            .then(res => {
                obj.hideLoadingbar();
                if(res.errorCode != null) {
                    return;
                }
                let newBoard = JSON.parse(res.config.data)
                newBoard = newBoard.paperId;
                obj.toastInfo.message = obj.$i18nUtil.trans("TB036");
                obj.showToast(obj.toastInfo);
                obj.$router.push('/general/board/' + newBoard);
            })
            .catch(function(err) {
                console.log(err);
            })
        },
        showTodo() {
            let hanwha = $(location).attr("origin");
            window.open(
                hanwha + "/general/todoNewPage",
                "_blank",
                "width=1264, height=800"
            );
        },
        changeIntroStatus(event) {
            let obj = this;
            if(obj.introStatus === true) {
                let obj = this;
                let reqData = {
                    url : "/api/auth/org/changeIntroStatus",
                    method : "post",
                };
                obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => {
                    if(res.errorCode !== null) {
                        let errorCode = res.errorCode;
                        console.log(errorCode)
                    } else {
                        obj.$router.replace('/general/home');
                    }
                })
                .catch(err => {
                    
                })
            }
        },
        showOkrMain(){
            EventBus.$emit("showOkrMain");
        },
        showServiceMessage() {
            let info = {
                title: this.$i18nUtil.trans("title.preparation.notice","알림"),
                button : this.$i18nUtil.trans("button.preparation.confirm","확인"),
                contents : this.$i18nUtil.trans("message.preparation","서비스 준비중입니다.")
            };
            this.handleDialog(info);
        },
        /* 알림 Dialog */
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/cowork/general/intro/base/Intro.vue